import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { trackCTAClick } from '../../utils/analytics';
import { MASTERCLASS } from '../../config/masterclass';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/';
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (!isHome) return;
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [isHome]);

  const bg = isHome && !scrolled ? 'rgba(0,0,0,0)' : 'rgba(0,0,0,0.85)';

  return (
    <nav className="g-nav" style={{ background: bg }}>
      <a href="/" onClick={e => { e.preventDefault(); navigate('/'); }} className="flex flex-col leading-none" style={{ textDecoration: 'none' }}>
        <span style={{ fontFamily: "'Cormorant Garamond',serif", fontWeight: 700, fontSize: 26, color: '#C9A235', letterSpacing: '0.02em' }}>OFS</span>
        <span style={{ fontFamily: "'Inter',sans-serif", fontWeight: 700, fontSize: 7, letterSpacing: '0.25em', color: 'rgba(201,162,53,0.6)', textTransform: 'uppercase', marginTop: -1 }}>ORDER FLOW SCHOOL</span>
      </a>
      <a href={MASTERCLASS.registrationUrl} className="g-nav-btn" data-testid="nav-cta" onClick={() => {
        trackCTAClick('Nav Secure My Spot');
      }}>Secure My Spot</a>
    </nav>
  );
};

export default Header;
